module.exports = __webpack_public_path__ + "static/media/reportingsite.9bdb45ab.pdf";